import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "onlineSupport" */ './index'),
  loading: () => null,
});
